import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  padding: 4rem;
`;

const Title = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 700;
  color: #042E4B;
  margin-bottom: 3rem;
  text-align: center;
`;

const GroupIllustration = styled(motion.div)`
  font-size: 8rem;
  margin-bottom: 3rem;
  text-align: center;
`;

const WordCloudContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  max-width: 1000px;
  margin-bottom: 3rem;
`;

const WordBubble = styled(motion.div)<{ size: 'large' | 'medium' | 'small' }>`
  background: white;
  padding: ${props => {
    switch (props.size) {
      case 'large': return '2rem 3rem';
      case 'medium': return '1.5rem 2.5rem';
      case 'small': return '1rem 2rem';
    }
  }};
  border-radius: 50px;
  font-size: ${props => {
    switch (props.size) {
      case 'large': return '2rem';
      case 'medium': return '1.6rem';
      case 'small': return '1.3rem';
    }
  }};
  font-weight: 600;
  color: #042E4B;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  border: 2px solid #EF443C;
`;

const BottomCard = styled(motion.div)`
  background: linear-gradient(135deg, #042E4B, #0A4A6F);
  color: white;
  padding: 3rem 5rem;
  border-radius: 20px;
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  max-width: 800px;
  box-shadow: 0 10px 30px rgba(4, 46, 75, 0.3);
`;

const Slide4Validacao: React.FC = () => {
  const concerns = [
    { text: 'Falta de tempo', size: 'large' as const },
    { text: 'Muito complexo', size: 'large' as const },
    { text: 'Não sei por onde começar', size: 'medium' as const },
    { text: 'Confusão', size: 'medium' as const },
    { text: 'Falta de clareza', size: 'medium' as const },
    { text: 'Dificuldade em mensurar', size: 'small' as const },
    { text: 'Sem acompanhamento', size: 'small' as const },
  ];

  return (
    <Container>
      <Title
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        Não é só o Tiago
      </Title>

      <GroupIllustration
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.1 }}
      >
        👥👥👥
      </GroupIllustration>

      <WordCloudContainer>
        {concerns.map((concern, index) => (
          <WordBubble
            key={`concern-${index}`}
            size={concern.size}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{
              duration: 0.3,
              delay: 0.2 + index * 0.05,
              type: 'spring',
              stiffness: 150,
            }}
          >
            {concern.text}
          </WordBubble>
        ))}
      </WordCloudContainer>

      <BottomCard
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.6 }}
      >
        Problema comum entre empreendedores
      </BottomCard>
    </Container>
  );
};

export default Slide4Validacao;
